import React from 'react';
import { useAuth } from '@/context/auth-context';
import Home from './home';
import ContentManagerDashboard from './ContentManagerDashboard';

/**
 * RoleDashboard - Routes users to the appropriate dashboard based on their role
 *
 * - site_content_manager: ContentManagerDashboard with focused actions
 * - super_admin / user: Standard Home dashboard with full navigation
 */
export default function RoleDashboard() {
  const { user } = useAuth();

  // Show content manager dashboard for content managers
  if (user?.role === 'site_content_manager') {
    return <ContentManagerDashboard />;
  }

  // Default to standard home dashboard
  return <Home />;
}
